import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Container, Spinner, Card, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { ProductContext } from "../../../context/AppContext";
import { KJUR } from "jsrsasign";

const getFormattedInitiateDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const ms = String(now.getMilliseconds()).padStart(3, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}000`;
};

const PayUPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Automationdata } = useContext(ProductContext);
  const { paymentDetails, authtoken: stateAuthToken } = location.state || {};
  const [formData, setFormData] = useState({
    amount: "",
    productinfo: "",
    firstname: "",
    email: "",
    phone: "",
    copyCheckId: [],
    // copyCheckId: "",
    registrationId: "",
    issueId: "",
    bookingId: "",
    canteenId: "",
    reqDocId: "", // Added for identity card
    eventBookingId: "",
    authToken: "",
    appId: "",
    sessionId: "",
    feeCollectionIds: [],
    feeCollHeaderIds: [],
    paymentMethod: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState(null);
  const [processing, setProcessing] = useState(false);
  const schoolLogo = Automationdata?.data?.[0]?.schoolLogo;
  const todayLabel = new Date().toLocaleDateString("en-GB");
  const amountLabel = formData.amount ? `₹${formData.amount}` : "₹0.00";
  const handleCancel = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }
    navigate(-1);
  };
  const styles = {
    page: {
      minHeight: "100vh",
      background: "linear-gradient(180deg, #e9eef6 0%, #eef2f7 100%)",
      padding: "32px 0",
    },
    card: {
      border: "1px solid #d7dce6",
      borderRadius: "12px",
      boxShadow: "0 16px 40px rgba(15, 23, 42, 0.08)",
    },
    logo: {
      height: "56px",
      width: "auto",
      objectFit: "contain",
    },
    title: {
      fontSize: "28px",
      fontWeight: "600",
      color: "#111827",
    },
    subtitle: {
      color: "#6b7280",
      fontSize: "15px",
    },
    detailsCard: {
      background: "#f4f5f7",
      borderRadius: "10px",
      border: "1px solid #e5e7eb",
      padding: "18px 20px",
    },
    detailRow: {
      display: "flex",
      justifyContent: "space-between",
      gap: "16px",
      padding: "6px 0",
      color: "#111827",
    },
    detailLabel: {
      color: "#6b7280",
      fontSize: "14px",
    },
    detailValue: {
      fontWeight: "500",
      fontSize: "14px",
    },
    divider: {
      borderTop: "1px solid #e5e7eb",
      margin: "12px 0",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontWeight: "600",
      color: "#111827",
    },
    linkButton: {
      background: "none",
      border: "none",
      color: "#6b7280",
      textDecoration: "underline",
      cursor: "pointer",
      padding: 0,
    },
    cancelButton: {
      border: "1px solid #d1d5db",
      background: "#fff",
      color: "#111827",
      padding: "12px 18px",
      borderRadius: "8px",
      minWidth: "180px",
    },
    confirmButton: {
      background: "#6d6bd6",
      border: "1px solid #6d6bd6",
      color: "#fff",
      padding: "12px 18px",
      borderRadius: "8px",
      minWidth: "180px",
    },
  };

  // Parse query parameters from URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const base64Data = queryParams.get("data");
    const paymentToken = queryParams.get("paymentToken");
    const authTokenFromQuery = queryParams.get("authToken");

    const decodePaymentToken = (token) => {
      try {
        const isValid = KJUR.jws.JWS.verifyJWT(token, "token", {
          alg: ["HS256"],
          verifyAt: KJUR.jws.IntDate.get("now"),
        });
        if (!isValid) return null;
        const parsed = KJUR.jws.JWS.parse(token);
        const payload = JSON.parse(parsed.payloadPP || "{}");
        return payload.paymentData || null;
      } catch (tokenError) {
        console.error("Invalid payment token:", tokenError);
        return null;
      }
    };

    let mergedData = {
      amount: queryParams.get("amount") || "",
      productinfo: queryParams.get("productinfo") || "",
      firstname: queryParams.get("firstname") || "",
      email: queryParams.get("email") || "",
      phone: queryParams.get("phone") || "",
      // copyCheckId: queryParams.get("copyCheckId") || "",
      copyCheckId: queryParams.get("copyCheckId")
        ? queryParams
          .get("copyCheckId")
          .split(",")
          .map(id => Number(id))
          .filter(id => !isNaN(id))
        : [],
      registrationId: queryParams.get("registrationId") || "",
      issueId: queryParams.get("issueId") || "",
      // bookingId: queryParams.get("bookingId") || "",
      canteenId: queryParams.get("canteenId") || "",
      reqDocId: queryParams.get("reqDocId") || "",
      eventBookingId: queryParams.get("eventBookingId") || queryParams.get("event_booking_id") || "",
      authToken: authTokenFromQuery || stateAuthToken || "",
      appId: queryParams.get("appId") || paymentDetails?.appId || "",
      sessionId: queryParams.get("sessionId") || paymentDetails?.sessionId || "",
      feeCollectionIds: queryParams.get("feeCollectionIds") ? queryParams.get("feeCollectionIds").split(",").map(id => parseInt(id.trim())) : [],
      feeCollHeaderIds: queryParams.get("feeCollHeaderIds") ? queryParams.get("feeCollHeaderIds").split(",").map(id => parseInt(id.trim())) : [],
      paymentMethod: queryParams.get("paymentMethod") || "",
    };

    // Handle base64 encoded data (for registration or fee)
    if (base64Data) {
      try {
        const decodedData = atob(base64Data);
        const parsedData = JSON.parse(decodedData);
        mergedData = {
          ...mergedData,
          productinfo: "Registration Fee", // Set for registration
          registrationId: parsedData.registrationId || "",
          amount: parsedData.amount.toString() || "",
          firstname: parsedData.firstname || "",
          email: parsedData.email || "",
          phone: parsedData.phone || "",
          authToken: authTokenFromQuery || stateAuthToken || "",
          paymentMethod: parsedData.paymentMethod || mergedData.paymentMethod || "",
        };
      } catch (error) {
        console.error("Error decoding Base64 data:", error);
      }
    }

    // Handle signed payment token (preferred secure flow)
    if (paymentToken) {
      const tokenData = decodePaymentToken(paymentToken);
      if (!tokenData) {
        setError("Invalid or expired payment link. Please initiate payment again.");
        return;
      }

      mergedData = {
        ...mergedData,
        amount: tokenData.amount?.toString() || "",
        productinfo: tokenData.productinfo || "",
        firstname: tokenData.firstname || "",
        email: tokenData.email || "",
        phone: tokenData.phone || "",
        authToken: tokenData.authToken || mergedData.authToken || "",
        appId: tokenData.appId || mergedData.appId || "",
        sessionId: tokenData.sessionId?.toString() || mergedData.sessionId || "",
        feeCollectionIds: Array.isArray(tokenData.feeCollectionIds)
          ? tokenData.feeCollectionIds.map((id) => parseInt(id, 10)).filter((id) => !Number.isNaN(id))
          : mergedData.feeCollectionIds,
        feeCollHeaderIds: Array.isArray(tokenData.feeCollHeaderIds)
          ? tokenData.feeCollHeaderIds.map((id) => parseInt(id, 10)).filter((id) => !Number.isNaN(id))
          : mergedData.feeCollHeaderIds,
        paymentMethod: tokenData.paymentMethod || mergedData.paymentMethod || "",
        classSectionId: tokenData.classSectionId?.toString() || mergedData.classSectionId || "",
        eventBookingId: tokenData.eventBookingId || tokenData.event_booking_id || mergedData.eventBookingId || "",
      };
    }

    // Set productinfo based on available IDs if not set
    if (!mergedData.productinfo) {
      if (mergedData.canteenId) mergedData.productinfo = "Canteen Order";
      else if (mergedData.copyCheckId) mergedData.productinfo = "Copy Review Fee";
      else if (mergedData.registrationId) mergedData.productinfo = "Registration Fee";
      else if (mergedData.issueId) mergedData.productinfo = "Book Fine Payment";
      else if (mergedData.bookingId) mergedData.productinfo = "Fee Collection";
      else if (mergedData.reqDocId) mergedData.productinfo = "Identity Card";
      else if (mergedData.feeCollectionIds.length) mergedData.productinfo = "Fee Collection";
    }

    // Set specific IDs based on productinfo
    if (mergedData.productinfo === "Registration Fee" && !mergedData.registrationId && base64Data) {
      // Already set from decoded
    } else if (mergedData.productinfo === "Registration Fee" && mergedData.registrationId) {
      // Good
    }

    setFormData(mergedData);
    console.log("Merged Form Data:", mergedData);

    // Check for payment status from query parameters
    const status = queryParams.get("status");
    const txnid = queryParams.get("txnid");
    const amount = queryParams.get("amount");
    const errorMessage = queryParams.get("error_Message");

    if (status) {
      setPaymentStatus(status);
      if (status.toLowerCase() === "success") {
        setPaymentMessage({
          variant: "success",
          message: `Your payment was successful! Transaction ID: ${txnid}, Amount: ₹${amount}`,
        });
      } else {
        setPaymentMessage({
          variant: "danger",
          message: `Your payment failed! Transaction ID: ${txnid || "N/A"}, Error: ${errorMessage || "Payment could not be processed"}`,
        });
      }
    }
  }, [location.search, paymentDetails, stateAuthToken]);

  // Listen for payment success or failure messages
  useEffect(() => {
    const handlePaymentStatus = (event) => {
      if (event.data.type === "payment_success" || event.data.type === "payment_failure") {
        const { txnid, status } = event.data;
        setPaymentStatus(status);
        setProcessing(false);
        if (status === "success") {
          setPaymentMessage({
            variant: "success",
            message: `Your payment was successful! Transaction ID: ${txnid}, Amount: ₹${formData.amount}`,
          });
        } else {
          setPaymentMessage({
            variant: "danger",
            message: `Your payment failed! Transaction ID: ${txnid || "N/A"}, Error: Payment could not be processed`,
          });
        }
      }
    };

    window.addEventListener("message", handlePaymentStatus);

    return () => {
      window.removeEventListener("message", handlePaymentStatus);
    };
  }, [formData.amount]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError(null);
    setPaymentMessage(null);
    setProcessing(true);
    setLoading(true);

    try {


      if (isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
        throw new Error("Please enter a valid amount (greater than 0)");
      }

      if (!formData.authToken) {
        throw new Error("Authentication token is missing");
      }

      if (formData.productinfo === "Fee Collection" && !formData.feeCollectionIds.length) {
        throw new Error("Fee Collection IDs are required");
      }
      if (formData.productinfo === "Fee Collection" && !formData.feeCollHeaderIds.length) {
        throw new Error("Fee Collection Header IDs are required");
      }

      // if (formData.productinfo === "Identity Card" && !formData.reqDocId) {
      //   throw new Error("Identity Card Request ID is required");
      // }

      const requestData = {
        amount: parseFloat(formData.amount),
        productinfo: formData.productinfo,
        firstname: formData.firstname,
        email: formData.email,
        phone: formData.phone,
        sessionId: formData.sessionId,
        feeCollectionIds: formData.feeCollectionIds,
        feeCollHeaderIds: formData.feeCollHeaderIds,
      };


      if (formData.productinfo === "Canteen Order") {
        requestData.canteenId = formData.canteenId;
      } else if (formData.productinfo === "Registration Fee") {
        requestData.registrationId = formData.registrationId;
      }
      // else if (formData.productinfo === "Copy Review Fee") {
      //   requestData.copyCheckId = formData.copyCheckId;
      else if (formData.productinfo === "Copy Review Fee") {
        requestData.copyCheckId = Array.isArray(formData.copyCheckId)
          ? formData.copyCheckId
          : [Number(formData.copyCheckId)];

      } else if (formData.productinfo === "Book Fine Payment") {
        requestData.issueId = formData.issueId;
      } else if (formData.productinfo === "Fee Collection") {
        requestData.bookingId = formData.bookingId;
      } else if (formData.productinfo === "Identity Card") {
        requestData.reqDocId = formData.reqDocId; // Added for identity card
      }

      if (formData.eventBookingId) {
        try {
          const initiateDate = getFormattedInitiateDate();
          await axios.put(
            `https://api.mirai.healthcare/api/student-details/event-booking/${formData.eventBookingId}`,
            { initiate_date: initiateDate },
            {
              headers: {
                "Content-Type": "application/json",
                "x-auth": formData.authToken,
              },
            }
          );
        } catch (eventBookingErr) {
          console.error("Error updating event booking initiate date:", eventBookingErr);
        }
      }

      const response = await axios.post(
        "https://api.mirai.healthcare/api/payment/payu-payment/initiate",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth": formData.authToken,
          },
          responseType: "text",
        }
      );

      // 🔥 CASE 1: API gives HTML form
      if (typeof response.data === "string" && response.data.includes("<form")) {
        document.open();
        document.write(response.data);
        document.close();
        return;
      }

      // 🔥 CASE 2: JSON response → create form
      const data = response.data;

      const mandatoryParams = [
        "key",
        "txnid",
        "amount",
        "productinfo",
        "firstname",
        "email",
        "phone",
        "surl",
        "furl",
        "hash",
      ];

      const missing = mandatoryParams.filter((p) => !data[p]);

      if (missing.length) {
        throw new Error("Missing params: " + missing.join(", "));
      }

      // 🔥 Create form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://test.payu.in/_payment";

      mandatoryParams.forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      document.body.appendChild(form);

      // ✅ Same tab submit
      form.submit();

    } catch (err) {
      console.error("Payment Error:", err);
      setError(err.message || "Payment failed");
      setProcessing(false);
    } finally {
      setLoading(false);
    }
  };

  const initiatePayment = async (paymentWindow, isRedirectFallback = false) => {
    try {
      setLoading(true);

      const requestData = {
        amount: parseFloat(formData.amount),
        productinfo: formData.productinfo,
        firstname: formData.firstname,
        email: formData.email,
        phone: formData.phone,
        sessionId: formData.sessionId,
        feeCollectionIds: formData.feeCollectionIds,
        feeCollHeaderIds: formData.feeCollHeaderIds,
      };

      const response = await axios.post(
        "https://api.mirai.healthcare/api/payment/payu-payment/initiate",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth": formData.authToken,
          },
          responseType: "text",
        }
      );

      // 🔥 CASE 1: API returns HTML form
      if (typeof response.data === "string" && response.data.includes("<form")) {

        if (isRedirectFallback) {
          // 👉 fallback: पूरा page replace
          document.open();
          document.write(response.data);
          document.close();
          return;
        }

        // 👉 popup me inject
        paymentWindow.document.open();
        paymentWindow.document.write(response.data);
        paymentWindow.document.close();

        return;
      }

      // 🔥 CASE 2: structured PayU response
      const data = response.data;

      const mandatoryParams = [
        "key",
        "txnid",
        "amount",
        "productinfo",
        "firstname",
        "email",
        "phone",
        "surl",
        "furl",
        "hash",
      ];

      const missing = mandatoryParams.filter((p) => !data[p]);

      if (missing.length) {
        throw new Error("Missing params: " + missing.join(", "));
      }

      const formHTML = `
      <html>
        <body>
          <form id="payuForm" action="https://test.payu.in/_payment" method="post">
            ${mandatoryParams
          .map((p) => `<input type="hidden" name="${p}" value="${data[p]}" />`)
          .join("")}
          </form>
          <script>
            document.getElementById("payuForm").submit();
          </script>
        </body>
      </html>
    `;

      if (isRedirectFallback) {
        document.open();
        document.write(formHTML);
        document.close();
        return;
      }

      paymentWindow.document.open();
      paymentWindow.document.write(formHTML);
      paymentWindow.document.close();

    } catch (err) {
      console.error("Payment Error:", err);

      if (paymentWindow) paymentWindow.close();

      setError(err.message || "Payment failed");
      setProcessing(false);
    } finally {
      setLoading(false);
    }
  };


  // Display Payment Processing
  if (processing) {
    return (
      <div style={styles.page}>
        <Container className="py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <Card style={styles.card} className="p-4 text-center">
                {schoolLogo && (
                  <div className="mb-3">
                    <img src={schoolLogo} alt="School Logo" style={styles.logo} />
                  </div>
                )}
                <h4>Payment Processing...</h4>
                <Spinner animation="border" variant="primary" className="my-3" />
                <p className="text-muted mb-0">
                  Please wait while we process your payment. Do not refresh or close this page.
                </p>
              </Card>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  // Display Payment Success/Failure
  if (paymentMessage) {
    return (
      <div style={styles.page}>
        <Container className="py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <Card style={styles.card} className="p-4 text-center">
                {schoolLogo && (
                  <div className="mb-3">
                    <img src={schoolLogo} alt="School Logo" style={styles.logo} />
                  </div>
                )}
                <h4>{paymentMessage.variant === "success" ? "Payment Successful" : "Payment Failed"}</h4>
                <Alert variant={paymentMessage.variant} className="my-3">
                  {paymentMessage.message}
                </Alert>
                <Button variant="primary" onClick={() => navigate("/")} className="mt-2">
                  Return
                </Button>
              </Card>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  // Payment Form
  return (
    <div style={styles.page}>
      <Container className="py-4">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-9">
            <Card style={styles.card} className="p-4">
              <div className="d-flex flex-column align-items-start">
                {schoolLogo && (
                  <div className="mb-3">
                    <img src={schoolLogo} alt="School Logo" style={styles.logo} />
                  </div>
                )}
                <div style={styles.title}>Confirm your payment</div>
                <div style={styles.subtitle}>Quickly and secure, free transactions.</div>
              </div>

              {error && (
                <Alert variant="danger" className="mt-3">
                  {error}
                </Alert>
              )}

              <div className="mt-4" style={styles.detailsCard}>
                <div className="fw-semibold mb-2">Details</div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Date</span>
                  <span style={styles.detailValue}>{todayLabel}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Payment method</span>
                  <span style={styles.detailValue}>{formData.paymentMethod || "PayU"}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Product</span>
                  <span style={styles.detailValue}>{formData.productinfo || "-"}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Student name</span>
                  <span style={styles.detailValue}>{formData.firstname || "-"}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Email</span>
                  <span style={styles.detailValue}>{formData.email || "-"}</span>
                </div>
                <div style={styles.detailRow}>
                  <span style={styles.detailLabel}>Phone</span>
                  <span style={styles.detailValue}>{formData.phone || "-"}</span>
                </div>
                <div style={styles.divider} />
                <div style={styles.totalRow}>
                  <span>Total amount</span>
                  <span>{amountLabel}</span>
                </div>
              </div>



              <Form className="mt-4">
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                  <Button
                    type="button"
                    onClick={handleCancel}
                    style={styles.cancelButton}
                    disabled={loading}
                  >
                    Cancel Payment
                  </Button>
                  <Button
                    type="button"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Confirm Payment"}
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PayUPayment;
